import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'periodoBimestre'
})
export class PeriodoBimestrePipe implements PipeTransform {

  transform(value: string): string {
    if (!value || value === 'Recuperação Final') {
      return '-';
    }
    return value.replace(/Período/gi, 'Bimestre');
  }

}
